import axios from 'axios'

export const getCSVAssignmentReq = ({ accountID }) => axios.get(`/products/${accountID}/channelProductAssignment/CSV`)

export const getCSVAttributesReq = ({ accountID }) => axios.get(`/products/${accountID}/productAttributes/CSV`)
